module.exports = __webpack_public_path__ + "img/propansaeurebutylester.d5eec20e.png";